import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import ratingPhoto from '../../resources/Single Rating Icon.jpeg';
import galleryPhoto from '../../resources/Gallery Icon.jpeg';
import findLocationPhoto from '../../resources/Find Location Icon.jpeg';
import findUsernamePhoto from '../../resources/Find Username Icon.jpeg';
const SearchUser = () => {
  const navigate = useNavigate();

  return (
    <div className="content-block bg-light p-3 rounded">
      <h1 className="text-center menu-title">Search User</h1>
      <Row className="mb-4">
        <Col xs={6} className="text-center">
          <Button
            variant="outline-primary"
            className="thumbnail raised-button main-menu-button photo-button"
            onClick={() => navigate('/individual-rating')}
          >
            <img
              src={ratingPhoto}
              alt="Individual Rating"
              className="menu-icon icon"
            />
          </Button>
          <div className="menu-label mt-2">Individual Rating</div>
          {/* New Hint Text Added Here */}
          <div className="hint-text">Chat Possible</div>
        </Col>

        <Col xs={6} className="text-center">
          <Button
            variant="outline-success"
            className="thumbnail raised-button main-menu-button photo-button"
            onClick={() => navigate('/gallery')}
          >
            <img
              src={galleryPhoto}
              alt="Gallery"
              className="menu-icon icon"
            />
          </Button>
          <div className="menu-label mt-2">Gallery</div>
          <div className="hint-text">To send requests</div>

        </Col>
      </Row>

      <Row>
        <Col xs={6} className="text-center">
          <Button
            variant="outline-danger"
            className="thumbnail raised-button main-menu-button photo-button"
            onClick={() => navigate('/find-user-location')}
          >
            <img
              src={findLocationPhoto}
              alt="Find Location"
              className="menu-icon icon"
            />
          </Button>
          <div className="menu-label mt-2">Find Location</div>
        </Col>

        <Col xs={6} className="text-center">
          <Button
            variant="outline-secondary"
            className="thumbnail raised-button main-menu-button photo-button"
            onClick={() => navigate('/find-username')}
          >
            <img
              src={findUsernamePhoto}
              alt="Find Username"
              className="menu-icon icon"
            />
          </Button>
          <div className="menu-label mt-2">Find Username</div>
        </Col>
      </Row>
    </div>
  );
};

export default SearchUser;